import axios from 'axios'

class AtlasService {
  async getSystem () {
    const resp = await axios.get('/api/v1/protected/users/atlas/system')
    return resp
  }
}

export default new AtlasService()
